"use client";
import React from "react";
import AuctionInfo from "./AuctionInfo";
import AuctionImagesPreview from "./AuctionImagesPreview";
import { Flex } from "@radix-ui/themes";
import { Auction, AuctionSettings } from "@prisma/client";

interface Props {
  auction: Auction;
  auctionSettings: AuctionSettings;
}

const AuctionBanner = ({ auction, auctionSettings }: Props) => {
  return (
    <Flex
      className="flex-col items-center gap-0 md:flex-row md:mb-10 md:gap-6"
      justify="center"
      width="auto"
    >
      <AuctionInfo auction={auction} auctionSettings={auctionSettings} />
      <AuctionImagesPreview auction={auction} />
    </Flex>
  );
};

export default AuctionBanner;
